import { Component, OnInit } from '@angular/core';
import { InstructorService, CourseService, UserService } from 'src/app/_services/generatedServices';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Router } from '@angular/router';
import { SettingsProvider } from '../../_services/settingsProvider.service';
import { ResizedEvent } from 'angular-resize-event';
import { forkJoin } from 'rxjs';
import { ConferenceOrEventSummaryViewModel, CourseSearchParameters, CourseViewModelSimple } from 'src/app/_models/generatedModels';

@Component({
  selector: 'app-home-logged-in',
  templateUrl: 'home-logged-in.component.html',
})
export class HomeLoggedInComponent implements OnInit {
  initialized: boolean;
  currentBeakpoint: string;
  events: ConferenceOrEventSummaryViewModel[];
  searchParams: CourseSearchParameters;
  courses: CourseViewModelSimple[];
  featuredCourses: CourseViewModelSimple[];
  showExpandedFeaturedCourses: boolean = true;

  responsiveOptions2 = [
    {
      breakpoint: '1590px',
      numVisible: 4,
      numScroll: 1,
    },
    {
      breakpoint: '1200px',
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '992px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '768px',
      numVisible: 1,
      numScroll: 1, 
    },
  ];

  constructor(public settings: SettingsProvider, private userService: UserService, private router: Router, private instructorData: InstructorService, private courseData: CourseService, public auth: AuthenticationService) {}

  ngOnInit(): void {
    this.searchParams = new CourseSearchParameters();
    this.searchParams.completedCEUs = null;
    this.searchParams.conferenceId = null;
    this.searchParams.watched = null;
    this.searchParams.tag = null;
    this.searchParams.certifyingBodyId = null;
    this.searchParams.page = 0;
    this.searchParams.pageSize = 10;

    forkJoin([this.userService.getUpcomingConferencesAndEvents(4), this.userService.searchPurchasedCourses(this.searchParams), this.courseData.getFeatured(20)]).subscribe(results => {
      this.events = results[0];
      this.courses = results[1].results;
      this.featuredCourses = results[2];

      if (this.events.length > 0 || this.courses.length > 0) {
        this.showExpandedFeaturedCourses = false;
        this.featuredCourses = this.featuredCourses.slice(0, 10);
      }
      
      this.initialized = true;
    });
  }

  onResized(event: ResizedEvent) {
    //this.isMobile = event.newWidth < 576;

    if (event.newRect.width < 576) {
      this.currentBeakpoint = 'xs';
    }
    if (event.newRect.width >= 576) {
      this.currentBeakpoint = 'sm';
    }
    if (event.newRect.width >= 768) {
      this.currentBeakpoint = 'md';
    }
    if (event.newRect.width >= 992) {
      this.currentBeakpoint = 'lg';
    }
    if (event.newRect.width >= 1200) {
      this.currentBeakpoint = 'xl';
    }
    if (event.newRect.width >= 1590) {
      this.currentBeakpoint = 'xxl';
    }
  }
}
